import { render } from "./EventHostView.vue?vue&type=template&id=4ec42b59&scoped=true"
import script from "./EventHostView.vue?vue&type=script&lang=js"
export * from "./EventHostView.vue?vue&type=script&lang=js"

import "./EventHostView.vue?vue&type=style&index=0&id=4ec42b59&scoped=true&lang=css"

import exportComponent from "/home/runner/work/fomofinal/fomofinal/fomoapp/frontend3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ec42b59"]])

export default __exports__